module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-04.c04d31e9.svg";